import { z } from 'zod';

import { StatsWindowSchema } from '../../stats/stats-range/stats-range';
import { BreakdownRowSchema, ComparableCountSchema } from '../../stats/stats-shapes/stats-shapes';

/** One bucket of the reports chart, split by resolution (unresolved = filed − resolved). */
export const ReportVolumePointSchema = z
  .object({
    bucket: z.string(),
    filed: z.number().int().nonnegative(),
    upheld: z.number().int().nonnegative(),
    noAction: z.number().int().nonnegative(),
    invalid: z.number().int().nonnegative(),
  })
  .strict();

export type ReportVolumePoint = z.infer<typeof ReportVolumePointSchema>;

/** The Dashboard's Safety section, reports half (D12). */
export const ReportStatsSchema = z
  .object({
    window: StatsWindowSchema,
    filed: ComparableCountSchema,
    resolved: z.number().int().nonnegative(),
    byReason: z.array(BreakdownRowSchema),
    perBucket: z.array(ReportVolumePointSchema),
  })
  .strict();

export type ReportStats = z.infer<typeof ReportStatsSchema>;
